<template>
  <Form padding="0px">
    <div>
      {{ $t("buyForm.second.title") }}
    </div>

    <div class="ss-elements">
      <div class="ss-select">
        <span>
          {{ $t("buyForm.second.tokenLabel") }}
        </span>
        <AuSelect
          :value="token"
          :options="tokensOptions"
          no-options="Loading..."
          image
          border-radius="14"
          :placeholder="$t('buyForm.second.tokenPlaceholder')"
          @input="tokenSelect"
        />
        <div class="ss-btn-place">
          <AuButton
            v-if="showUSDT"
            center
            padding-horizontal="12px"
            @click="setToken(defaultCurrency)"
          >
            <div class="ss-btn-content">
              <img
                class="ss-image"
                src="/svg/buyForm/usdt.svg"
                alt=""
              >
              {{ defaultCurrency }}
            </div>
          </AuButton>
          <AuButton
            v-if="showAUT"
            center
            padding-horizontal="12px"
            @click="setToken(autName)"
          >
            <div class="ss-btn-content">
              <img
                class="ss-image"
                src="/svg/buyForm/aut.svg"
                alt=""
              >
              {{ autName }}
            </div>
          </AuButton>
        </div>
      </div>
      <div class="ss-select">
        <span>
          {{ $t("buyForm.second.networkLabel") }}
        </span>
        <AuSelect
          :value="network"
          :options="networkOptions"
          :disabled="token === null"
          border-radius="14"
          :placeholder="$t('buyForm.second.networkPlaceholder')"
          @input="networkSelect"
        />
      </div>
      <div
        v-if="error"
        class="ss-error"
      >
        {{ error }}
      </div>
      <ProgressLoader
        v-if="isLoad"
        mode="indeterminate"
        color="#5AC396"
        size="150px"
      />
      <div v-if="!isLoad && showConfirm && !showAdr && !error">
        <div class="ss-separator" />
        <p class="ss-explain">
          {{ $t("buyForm.second.txtDeposite") }}
        </p>
        <p class="ss-explain">
          {{ $t("buyForm.second.txtSend", {defaultCurrency}) }}
        </p>
        <div class="ss-explain">
          {{ $t("buyForm.second.listHeader") }}
        </div>
        <div class="ss-explain">
          {{ $t("buyForm.second.listOne", { network }) }}
        </div>
        <div class="ss-explain">
          {{ $t("buyForm.second.listTwo", {defaultCurrency}) }}
        </div>
        <p class="ss-explain">
          {{ $t("buyForm.second.listThree") }}
        </p>
        <p class="ss-explain">
          {{ $t("buyForm.second.txtFunds", { network }) }}
        </p>
        <div class="ss-separator" />
        <p>{{ tokenName }}</p>
        <p>{{ network }}</p>
      </div>
      <div v-if="!isLoad && showAdr && !showConfirm">
        <div class="ss-separator" />
        <div class="ss-explain">
          {{ $t("buyForm.second.adrDeposit") }}
        </div>
        <div
          class="ss-adr"
          :dark="!isLightTheme"
        >
          <img
            v-if="qrCode"
            :src="qrCode"
          >
          <div class="ss-copy">
            <span>{{ address }}</span>
            <SuccessMark
              v-show="copied"
              :show-animate="copied"
            />
            <img
              v-show="!copied"
              class="ss-icon"
              src="/svg/buyForm/copy.svg"
              alt=""
              @click="copyAddress"
            >
          </div>
        </div>
        <p class="ss-explain">
          {{
            $t("buyForm.second.adrExplain1") +
              ` ${tokenName} ` +
              $t("buyForm.second.adrExplain2") +
              ` ${network} ` +
              $t("buyForm.second.adrExplain3")
          }}
        </p>
        <p class="ss-explain">
          {{ $t("buyForm.second.adrExplain4") }}
        </p>
      </div>
    </div>

    <template #footer>
      <div
        v-if="!isLoad && showConfirm && !showAdr && !error"
        class="btn-footer"
      >
        <AuButton
          center
          type="secondary"
          @click="backStep"
        >
          {{ $t("buyForm.second.backStep") }}
        </AuButton>
        <AuButton
          center
          type="primary"
          :is-progress="isNotify"
          @click="nextStep"
        >
          {{ $t("buyForm.second.nextStep") }}
        </AuButton>
      </div>

      <div
        v-if="!isLoad && !showConfirm && showAdr"
        class="btn-footer"
      >
        <AuButton
          center
          type="secondary"
          @click="backStep"
        >
          {{ $t("buyForm.second.backStep") }}
        </AuButton>
        <AuButton
          center
          type="primary"
          :is-progress="isNotify"
          @click="nextStage"
        >
          {{ $t("buyForm.second.next") }}
        </AuButton>
      </div>
    </template>
  </Form>
</template>

<script>
import _ from "lodash";
import ProgressLoader from "@/loaders/progress-bar";
import QRCode from "qrcode";
import SuccessMark from "@/components/SuccessMark.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SecondStage",
  components: {
    ProgressLoader,
    SuccessMark
  },
  data() {
    return {
      tokensDeposit: null,
      token: null,
      network: null,
      networkOptions: [],
      address: null,
      qrCode: null,
      payId: null,
      isLoad: false,
      showAdr: false,
      showConfirm: false,
      copied: false,
      isNotify: false,
      autName: "AUT",
      error: null
    };
  },
  computed: {
    ...mapGetters({
      language: "language",
      isLightTheme: "isLightTheme",
      tokensUtility: "tokensUtility",
      tokensFiat: "tokensFiat",
      ethAddresses: "ethAddresses",
      defaultTokenId: "defaultToken/defaultTokenId",
      defaultTokenMnemonic: "defaultToken/defaultTokenMnemonic",
      defaultTokenEnv: "defaultToken/defaultTokenEnv",
      isTestRole: "profile/isTestRole",
      profile: "profile/profile"
    }),

    addressFrom() {
      return (
        (Array.isArray(this.ethAddresses)
          ? this.ethAddresses.at(0)?.value
          : this.ethAddresses) ?? "-"
      );
    },

    defaultCurrency() {
      return process.env.VUE_APP_CURRENCY_DEFAULT;
    },

    tokensOptions() {
      const buf = {};
      for (const blockchain in this.tokensDeposit?.tokens) {
        _.forEach(
          Object.keys(this.tokensDeposit?.tokens[blockchain]),
          (token) => {
            const name = this.tokensDeposit?.tokens[blockchain][token]?.name;
            const image =
              this.tokensDeposit?.tokens[blockchain][token]?.iconUrl;
            if (!(name in buf)) {
              buf[name] = { image: image, blockchain: [] };
            }
            buf[name].blockchain.push(blockchain);
            buf[name].symbol = token;
          }
        );
      }
      if (this.isTestRole == false) {
        const fakeKey = _.filter(
          Object.keys(buf),
          (key) => /fake/i.test(key) || /test/i.test(key)
        );
        if (fakeKey) {
          for (const key of fakeKey) {
            delete buf[key];
          }
        }
      }
      const ret = _.map(buf, (value, key) => ({
        display: key,
        value: key,
        tokenSymbolToDeposit: value.symbol,
        blockchains: value.blockchain,
        image: value.image ?? this.getTokenImage(key)
      }));

      return ret.sort((a, b) => {
        return a.display === b.display ? 0 : a.display > b.display ? 1 : -1;
      });
    },

    selectedNetwork() {
      return _.find(this.networkOptions, (item) => item.value === this.network);
    },

    type() {
      return this.selectedNetwork?.type;
    },

    urlScan() {
      return this.selectedNetwork?.url_scan;
    },

    tokenName() {
      return _.find(this.tokensOptions, (item) => item.value === this.token)
        ?.display;
    },

    showUSDT() {
      return (
        _.find(
          this.tokensOptions,
          (token) => token.display === "USDT"
        ) !== undefined
      );
    },

    showAUT() {
      return (
        _.find(
          this.tokensOptions,
          (token) => token.display === this.autName
        ) !== undefined
      ) && !/autentic/i.test(process.env.VUE_APP_PLATFORM);
    }
  },

  async mounted() {
    this.tokensDeposit = await this.getDepositTokens();
  },

  methods: {
    ...mapActions({
      payCreate: "payCreate",
      payNotify: "payNotify",
      getDepositTokens: "getDepositTokens"
    }),

    getTokenImage(tokenName) {
      if (tokenName === "USDT") {
        return "/svg/buyForm/usdt.svg";
      }
      if (tokenName === this.defaultCurrency) {
        return "/svg/buyForm/usdt.svg";
      }
      if (tokenName === "ISLM") {
        return "/svg/buyForm/islm.svg";
      }
      if (tokenName === "Deenar") {
        return "/svg/buyForm/deen.svg";
      }
      if (tokenName === "AUT") {
        return "/svg/buyForm/aut.svg";
      }
      return "/svg/companies/s_logo.svg";
    },

    tokenSelect(value) {
      this.token = value;
      this.network = null;
      this.networkOptions.length = 0;
      this.showAdr = false;
      this.error = null;
      this.showConfirm = false;
      const unique = new Set();

      const blockchains = _.find(
        this.tokensOptions,
        (token) => token.value === value
      ).blockchains;
      _.forEach(blockchains, (network) => {
        const type = this.tokensDeposit?.nodes[network]?.type ?? "evm";
        const name = this.tokensDeposit?.nodes[network]?.name;
        const url_scan = this.tokensDeposit?.nodes[network]?.url_scan;
        unique.add({
          display: name,
          value: name,
          type: type,
          url_scan: url_scan
        });
      });
      this.networkOptions = [...unique.values()];
      if (this.networkOptions.length === 1) {
        this.networkSelect(this.networkOptions[0].value);
      }
      else {
        this.networkOptions = this.networkOptions.sort((a, b) => {
          return a.display === b.display ? 0 : a.display > b.display ? 1 : -1;
        });
      }
    },

    setToken(tokenName) {
      this.tokenSelect(
        _.find(this.tokensOptions, (token) => token.display === tokenName)
          ?.value
      );
    },

    async networkSelect(value) {
      this.network = value;
      this.showAdr = false;
      this.error = null;
      await this.getAddress();
    },

    async getAddress() {
      this.isLoad = true;
      let params = null;
      try {
        if (this.type == "ton") {
          const token = _.find(this.tokensOptions, { value: this.token });
          const clearSymbol = token.tokenSymbolToDeposit.replace("STAGE:", "");
          const depositToken =
            this.tokensDeposit.tokens[this.type][clearSymbol];
          params = {
            networkName: this.type,
            tokenType: depositToken.tokenType || "token",
            tokenSymbolToReceive: depositToken.tokenSymbolToReceive,
            tokenSymbolToDeposit: clearSymbol
          };
        }
        else {
          params = {
            networkName: this.type
          };
        }
        const resp = await this.payCreate(params);
        this.address = resp.address;
        this.payId = resp.payId;
        this.qrCode = await QRCode.toDataURL(this.address);
        this.error = null;
        this.showConfirm = true;
        this.$emit("setAddress", this.address);
      }
      catch (e) {
        this.showAdr = false;
        this.error = this.$t("buyForm.second.adrError");
      }
      this.isLoad = false;
    },

    async nextStage() {
      this.isNotify = true;
      await this.payNotify(this.payId);
      this.isNotify = false;
      this.$emit("next", { tokenName: this.tokenName, urlScan: this.urlScan });
    },

    copyAddress() {
      navigator.clipboard.writeText(this.address).then(() => {
        this.copied = true;
        setTimeout(() => (this.copied = false), 1700);
      });
    },

    showError(message) {
      this.$toast.error(message);
    },

    nextStep() {
      this.showAdr = true;
      this.showConfirm = false;
    },

    backStep() {
      this.error = null;
      this.network = null;
      this.showAdr = false;
      this.showConfirm = false;
    }
  }
};
</script>

<style lang="scss">
.ss-elements button.btn .btn__text {
  @media screen and (max-width: 600px) {
    font-size: 14px !important;
  }

  @media screen and (max-width: 450px) {
    font-size: 11px !important;
  }
}
</style>

<style scoped lang="scss">
.ss-explain {
  font-size: 16px;
}
.ss-select {
  margin-top: 15px;
  width: 100%;
  span {
    color: var(--color-50);
  }

  &first-child {
    margin-top: 0px;
  }
}
.ss-btn-place {
  margin-top: 7px;
  display: flex;
  gap: 5px;
}
.ss-separator {
  border-bottom: 3px solid green;
  width: 200px;
  margin: 20px 0;
}
.ss-adr {
  display: flex;
  justify-content: space-between;
  background-color: #e5e5e5;
  border-radius: 15px;
  padding: 18px 24px 18px 18px;
  margin: 10px 0;
  &[dark="true"] {
    background-color: #363535;
  }
  @media screen and (max-width: 400px) {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
}
.ss-copy {
  width: 70%;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;

  @media screen and (max-width: 600px) {
    width: 60%;
    font-size: 15px;
  }

  @media screen and (max-width: 500px) {
    width: 50%;
    font-size: 11px;
  }

  span {
    width: 90%;
    word-wrap: break-word;
    text-align: center;
    @media screen and (max-width: 500px) {
      width: 70%;
    }
    @media screen and (max-width: 600px) {
      width: 80%;
    }
  }
}
.ss-btn-content {
  display: flex;
  align-items: center;
  gap: 5px;
}
.ss-image {
  width: 25px;
  height: 25px;
}
.ss-icon {
  cursor: pointer;
  width: 48px;
  height: 44px;
  @media screen and (max-width: 800px) {
    height: 25px;
  }
}
.ss-error {
  color: red;
  margin-top: 15px;
}
.btn-footer {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
</style>
